import { Controller } from '@hotwired/stimulus';

import { differenceInSeconds, parseISO } from 'date-fns';

import formatSeconds from '../../utils/format_seconds';

export default class TimerController extends Controller {
  static values = {
    startTime: String
  };

  static targets = [
    'elapsedTime',
    'testTimeField'
  ];

  constructor() {
    super(...arguments);

    this.startTime = parseISO(this.startTimeValue);
  }

  tick({ detail: { now } }) {
    const elapsedSec = differenceInSeconds(now, this.startTime);

    for (const el of this.elapsedTimeTargets) {
      el.textContent = formatSeconds(elapsedSec);
    }

    if (this.hasTestTimeFieldTarget) {
      this.testTimeFieldTarget.value = elapsedSec;
    }
  }
}
